import type { ReactNode } from 'react';

type LabelPropsType = {
  htmlFor?: string;
  children: ReactNode;
};

const Label = ({ htmlFor, className, children }: LabelPropsType) => (
  <label className={className} htmlFor={htmlFor}>
    {children}
  </label>
);

export default Label;
